module.exports = function($scope) {
  $scope.item = {};

  if ($scope.ngDialogData.raisedFundItem)
    {

    $scope.amount = $scope.ngDialogData.raisedFundItem.amount;
        $scope.item.id = $scope.ngDialogData.raisedFundItem.id;
        $scope.item.amount = $scope.ngDialogData.raisedFundItem.amount;
        $scope.item.organisation =  $scope.ngDialogData.raisedFundItem.organisation;
        $scope.item.grantPaid =  $scope.ngDialogData.raisedFundItem.grantPaid;
        $scope.item.receivedOn =  $scope.ngDialogData.raisedFundItem.receivedOn;
        $scope.item.grantExpected =  $scope.ngDialogData.raisedFundItem.grantExpected;
        $scope.item.anySpecialConditions =  $scope.ngDialogData.raisedFundItem.anySpecialConditions;
        $scope.item.specialConditions =  $scope.ngDialogData.raisedFundItem.specialConditions;
    }

  if (!$scope.item.id) {
    $scope.creating = true;
  }

  $scope.submit = function() {
    $scope.loading = true;

    var p = $scope.creating
      ? $scope.ngDialogData.create($scope.item)
      : $scope.ngDialogData.update($scope.item);

    p.then(function() {
      $scope.loading = false;
      $scope.closeThisDialog({ action: "ok" });
    });

  }

  $scope.cancel = function(e) {
    e.preventDefault();
    $scope.closeThisDialog({ action: "cancel" });
  }

  $scope.delete = function(e) {
    e.preventDefault();
    $scope.ngDialogData.del($scope.item).then(function() {
      $scope.closeThisDialog({ action: "ok" });
    });
  }

}
